<template>

  <v-layout row wrap justify-space-between>
    <v-flex px-3 sm12 xs12 md6 lg6 v-bind:key="index" v-for="(app, index) in apps">
      <v-card  class="elevation-0 mb-3 border-grey radius-0 account-list">
        <div class="c-layout">
          <div class="cl-flex6 bg-grey  v-center">
            <img v-if="app.image_url" :src="app.image_url" class="account-logo"/>
            <img v-else src="../../../../assets/images/uno-logo.png" class="account-logo"/>
          </div>
          <div class="cl-flex6">
            <div class="min-h-80 section-excerpt pa-3 v-center">
              <h2 class="font-weight-bold heading-with-border relative">{{ app.display_name }}</h2>
              <p class="app-description">{{ app.name }}</p>
                <div class="c-layout w-100  pb-1">
                  <div class="cl-flex12 text-xs-left">
                    <p class="mb-0 mt-3">Ver: {{ app.appDetail ? app.appDetail.version: 'N/A' }}</p> 
                  </div>
                  <div class="cl-flex12 text-xs-left mt-2">

                     <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          @click="addAppToBusiness(app)"
                          slot="activator"
                          fab 
                          small
                          dark 
                          color="primary"
                          v-on="on"
                          depressed
                          :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2 xs-small' : 'ml-3 xs-small'"
                        >
                          <v-icon dark>business</v-icon>
                        </v-btn>
                      </template>
                      <span>Add to Business</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          @click="addResources(app)"
                          slot="activator"
                          fab 
                          small
                          dark 
                          color="primary"
                          v-on="on"
                          depressed
                          :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2 xs-small' : 'ml-3 xs-small'"
                        >
                          <v-icon dark>add</v-icon>
                        </v-btn>
                      </template>
                      <span>Add App resources </span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          @click="showResources(app)"
                          slot="activator"
                          fab 
                          small
                          dark 
                          color="primary"
                          v-on="on"
                          depressed
                          :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2 xs-small' : 'ml-3 xs-small'"
                        >
                          <v-icon dark>fas fa-info-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Show App resources</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          @click="updateAppDetail(app)"
                          slot="activator"
                          fab 
                          small
                          dark 
                          color="primary"
                          v-on="on"
                          depressed
                          :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2 xs-small' : 'ml-3 xs-small'"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Update App Details</span>
                    </v-tooltip>
                  </div>
                </div>    
            </div>
          </div>
        </div>
      </v-card>
    </v-flex>
    <v-flex sm12 md12 v-if="apps.length < 1">
      <p class="text-xs-center">No apps.</p>
    </v-flex>
  </v-layout>

</template>
<script>
import Env from '@/env';
import store from '@/store/store';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapGeters, mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    authToken() {
      return this.$store.getters.getLoggedInUserToken;
    },
    userCanManageApp() {
      return this.$store.getters.getUserCanAddApp;
    },
    ...mapGetters({
      apps: 'superadminapps/list',

    }),
  },
  created() {
    this.fetchSuperadminApps();
  },
  methods: {
    /**
     * Fetch all apps 
     */ 
    fetchSuperadminApps() {
      const url = `${Env.url}/api/v1/apps`;
      AuthApi.getApi(url)
        .then((res) => {
          this.setList(res.data.payload);
        })
        .catch(() => {
          console.log('Unale to fetch superadmin applications.')
        });
    },

    /**
     * Add app to bbusiness
     */
    addAppToBusiness(obj) {
      this.setAddAppToBusiness(true);
      this.setAddAppToBusinessObj(obj);
    },

    /**
     * Add resources
     */
    addResources(obj) {
      this.setaddResources(true);
      this.setaddResourcesObj(obj);
    },

    /**
     * Show resources
     */
    showResources(obj) {
      this.setShowResources(true);
      this.setShowResourcesObj(obj);
    },
    /**
    * Update app details
    */
    updateAppDetail(obj){
      this.setEditAppDetail(true);
      this.setEditAppDetailObj(obj);
    },
    ...mapActions({
      setList: 'superadminapps/setList',
      setAddAppToBusiness: 'superadminapps/setAddAppToBusiness',
      setAddAppToBusinessObj: 'superadminapps/setAddAppToBusinessObj',
      setaddResources: 'superadminapps/setAddResources',
      setaddResourcesObj: 'superadminapps/setAddResourcesObj',
      setShowResources: 'superadminapps/setShowResources',
      setShowResourcesObj: 'superadminapps/setShowResourcesObj',
      setEditAppDetail: 'superadminapps/setEdit',
      setEditAppDetailObj: 'superadminapps/setEditObj',
    }),

  },
};
</script>

